module.exports = __webpack_public_path__ + "img/desktop-computer.d2021039.png";